import get from 'lodash/get';
import omit from 'lodash/omit';

import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import TextField from '@mui/material/TextField';
import OutlinedInput from '@mui/material/OutlinedInput';

import CustomInput from './CustomInput';
import {ChevronDownIcon} from "../../styles/icons";
import './CustomSelect.css';

const handleChange = props => {
  if (props.multiple) {
    return (e, values) => {
      props.onChange({target: {value: values || null}});
    };
  }
  return (e, opt) => {
    props.onChange({target: {value: opt ? opt.value : null}});
  }
};

const CustomSelect = props => {
  // const [value, setValue] = useState(
  //   props.multiple
  //   ? props.defaultValue
  //   : ((props.options || []).find(o => o.value === props.defaultValue) || null)
  // );
  // const opts = get(props, 'options', []);
  let childProps = {
    id: 'custom-select',
    options: props.options || [],
    defaultValue: (props.options || []).find(o => o.value === props.defaultValue),
    // value: value === null && props.multiple ? [] : value,
    disabled: props.disabled || false,
    onChange: handleChange(props),
    multiple: props.multiple || false,
    style: {backgroundColor: '#ffffff'},
    sx: props?.sx || {},
    size: props.size || 'medium',
    variant: props.variant || null,
    fullWidth: props?.fullWidth || false,
    colorText: props.colorText,
    colorIcon: props.colorIcon,
    textAlign: props.textAlign,
    noBorder: props.noBorder,
    getOptionLabel: (o, y, z) => get(o, 'label'),
    renderInput: (params) => (
      <TextField
        {...params}
        {...omit(props, 'label', 'helperText')}
      />
    ),
    getOptionDisabled: (!!props.getOptionDisabled ? props.getOptionDisabled : o => !!o?.disabled),
    disableClearable: props.disableClearable || false,
    disableCloseOnSelect: props.disableCloseOnSelect || false,
    renderOption: props?.renderOption,
    renderValue: props?.renderValue,
    color: props?.color || null,
    // renderOption: (_props, option) => {
    //   const index = findIndex(opts, o => o.value === option.value);
    //   return (
    //     <Box
    //       key={option.value}
    //       component='li'
    //       {..._props}
    //       sx={{
    //         borderBottom: (
    //           index === (opts.length - 1)
    //           ? 'none'
    //           : '1px solid rgba(0,0,0,0.10)'
    //         ),
    //       }}
    //       onClick={() => {
    //         setValue({value: option.value, label: option.label});
    //         props.onChange({target: {value: option.value}})
    //       }}
    //     >
    //       <Stack direction='row' padding={1}>
    //         {option.label}
    //       </Stack>
    //     </Box>
    //   );
    // },
  };
  // set configuration for multi-selects
  if (props.multiple) {
    if (props.defaultValue) {
      childProps.defaultValue = props.defaultValue.map(val =>
        props.options.find(o => o.value === val)
      );
    }
    childProps.filterSelectedOptions = props.filterSelectedOptions || false;
    childProps.input = <OutlinedInput id="select-multiple-chip" label="Chip" />;
    childProps.renderValue = (selected) => (
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5}}>
        {selected.map((value) => (
          <Chip key={value} label={value} />
        ))}
      </Box>
    );
  } else {
    // childProps.renderInput = (params) => (
    //   <TextField
    //     {...params}
    //     {...omit(props, 'label', 'helperText')}
    //   />
    // );
  }
  // AutoComplete arrow icon
  childProps.popupIcon = props.popupIcon ? props.popupIcon : <ChevronDownIcon />;
  return (
    <CustomInput {...omit(props, 'children')} className='CustomSelect'>
      <Autocomplete {...childProps} />
    </CustomInput>
  );
};

export default CustomSelect;
